import Vue from 'vue'
// axios
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

const axiosIns = axios.create({
  baseURL: process.env.MODE_APP === 'prod' ? process.env.AWS_BASE_URL_PROD : process.env.AWS_BASE_URL_DEV,
  headers: {
    ContentType: 'multipart/form-data',
  },
})

axiosIns.interceptors.request.use(config => {
  const accessToken = localStorage.getItem('accessToken')
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`
  }
  return config
}, error => Promise.reject(error))

Vue.prototype.$httpAWS = axiosIns
Vue.prototype.$apiAWS = axiosIns

export default axiosIns
